module.exports = __webpack_public_path__ + "img/43.cc39d778.jpg";